import { useSelector } from 'react-redux'
import * as yup from 'yup'
import 'yup-phone'

export type RequiredProfileField = {
  key: 'firstName' | 'lastName' | 'mobileNumber'
  label: string
}

const phoneSchema = yup.string().phone()

const hasMobileNumber = (value?: string | null): boolean => {
  if (!value) return false
  try {
    return phoneSchema.isValidSync(value)
  } catch {
    return false
  }
}

export const REQUIRED_PROFILE_FIELDS: RequiredProfileField[] = [
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'mobileNumber', label: 'Mobile Number' },
]

export const ALLOWED_INCOMPLETE_PROFILE_PATHS = [
  '/admin/profile',
  '/admin/contact',
]

export const getMissingProfileFields = (user: any): RequiredProfileField[] => {
  if (!user) return []
  return REQUIRED_PROFILE_FIELDS.filter((field) =>
    field.key === 'mobileNumber'
      ? !hasMobileNumber(user.contact?.mobileNumber)
      : !user[field.key],
  )
}

export const isProfileComplete = (user: any): boolean =>
  !!user && getMissingProfileFields(user).length === 0

const useProfileComplete = () => {
  const user = useSelector((state: any) => state?.users?.user)
  const missingFields = getMissingProfileFields(user)

  return {
    user,
    missingFields,
    isComplete: !!user && missingFields.length === 0,
  }
}

export default useProfileComplete
